import { echo } from "./echo";
import { help } from "./help";
import { date } from "./date";
import { clear } from "./clear";
import { whoami } from "./whoami";
import { ls } from "./ls";
import { pwd } from "./pwd";
import { cat } from "./cat";
import { cd } from "./cd";

export const commandMap = {
    whoami,
    help,
    echo,
    date,
    clear,
    ls,
    cat,
    cd,
    pwd
};